module.exports = __webpack_public_path__ + "static/media/B_E02.9af64097.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/B_E02.png
// module id = 87
// module chunks = 0